import { hrefFor } from '../../../routers';

type SiteFooterLinkConfig = {
  label: string;
  href: string;
  isPopup?: boolean;
};

type SiteFooterLinkCategoryConfig = {
  name: string;
  links: SiteFooterLinkConfig[];
  description?: string[];
};

export const SITE_FOOTER_LINKS_CONFIG: SiteFooterLinkCategoryConfig[] = [
  {
    name: 'Contact Client Services',
    description: ['Monday - Friday 8am-8pm EST', 'Saturday - Sunday 9am-6pm EST'],
    links: [
      {
        label: 'Toll Free (US): 1 800-707-9898',
        href: 'tel:1 800-707-9898'
      },
      {
        label: 'International: +1 212-729-0984',
        href: 'tel:+1 212-729-0984'
      },
      {
        label: 'Email Client Services',
        href: 'mailto:care@modaoperandi.com'
      }
    ]
  },
  {
    name: 'Shipping & Returns',
    links: [
      {
        label: 'Track An Order',
        href: 'https://help.modaoperandi.com/hc/en-us/articles/210056706-Tracking-Your-Order',
        isPopup: true
      },
      {
        label: 'Return An Order',
        href: hrefFor.RequestReturnPage()
      },
      {
        label: 'Returns & Refunds',
        href: 'https://help.modaoperandi.com/hc/en-us/sections/202224966-Returns-Refunds',
        isPopup: true
      },
      {
        label: 'Shipping Times & Costs',
        href: 'https://help.modaoperandi.com/hc/en-us/articles/211521843-Shipping-Times-Costs',
        isPopup: true
      },
      {
        label: 'FAQs',
        href: 'https://help.modaoperandi.com/hc/en-us',
        isPopup: true
      }
    ]
  },
  {
    name: 'About Moda',
    links: [
      { label: 'Careers', href: '/about#careers' },
      { label: 'About Us', href: '/editorial/about-us' },
      { label: 'Contact Us', href: '/about#contact' },
      { label: 'Newsroom', href: '/editorial/newsroom' }
    ]
  },
  {
    name: 'How To Shop',
    links: [
      {
        label: 'Moda Rewards',
        href: '/rewards'
      },
      {
        label: 'Moda Private',
        href: '/editorial/moda-private'
      }
    ]
  }
];
